import React from 'react';

export default function TaxSetupCard(props) {
	return (
		<div className="TaxSetupCard bg-white w-full min-w-96 mt-4 p-5 rounded-md shadow border text-gray-800">
			<div className="grid lg:grid-cols-12 lg:gap-5">
				<div className="col-span-12 lg:col-span-2">
					<h2 className="text-lg lg:text-xl font-semibold mb-2">Tax Setup</h2>
				</div>
				<div className="col-span-12 lg:col-span-10">
					<div className="border p-4 bg-gray-50 shadow-sm rounded-md">
						<div className="font-semibold">Tax Rate</div>
						<ul className="list-disc ml-4">
							<li className="my-1 ml-1">
								4.715% - Maui GE (Honolulu City & County)
							</li>
							<li className="my-1	ml-1">
								10.0% - Transient Accommodations Tax (Maui)
							</li>
						</ul>
						<hr className='w-100'/>
						<ul className="ml-4">
							<li className="my-1	ml-1 font-semibold">
								14.715%
							</li>
						</ul>
					</div>
					<div className="mt-6 border p-4 bg-gray-50 shadow-sm rounded-md">
						<div className="font-semibold">Filing Schedules</div>
						<div className="mb-2">
							<div className="underline">Maui Monthly Online</div>
							<ul className="list-disc ml-4">
								<li className="my-1 ml-1">
									G-45 - General Excise/Use Tax Return
								</li>
								<li className="my-1	ml-1">
									TA-1 - Periodic Transient Accommodations Tax Return
								</li>
							</ul>
						</div>
						<div className="mb-2">
							<div className="underline">Maui Annual Online</div>
							<ul className="list-disc ml-4">
								<li className="my-1 ml-1">
									G-49 - General Excise/Use Annual Return & Reconciliation
								</li>
								<li className="
							my-1
							ml-1">
									TA-2 - Annual Transient Accommodations Tax Return &
									Reconciliation
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
